import { useCallback, useEffect, useRef, useState } from 'react';

const ARC_A = 'M 43.347 18.699 A 32 32 0 0 0 19.566 59.889';
const ARC_B = 'M 26.219 71.412 A 32 32 0 0 0 73.781 71.412';
const ARC_C = 'M 80.434 59.889 A 32 32 0 0 0 56.653 18.699';

const CORAL = '#FD584F';
const TEAL_LIGHT_BG = '#00918F';
const TEAL_DARK_BG = '#00C5C2';

export default function GyenoMark({
  size = 48,
  onDark = false,
  thinking = false,
  interactive = true,
  spinDuration = 850,
  onSpin,
  className = '',
  ...rest
}) {
  const [spinning, setSpinning] = useState(false);
  const timer = useRef(null);
  const teal = onDark ? TEAL_DARK_BG : TEAL_LIGHT_BG;

  useEffect(() => () => clearTimeout(timer.current), []);

  const spin = useCallback(() => {
    if (thinking || spinning) return;
    setSpinning(true);
    onSpin?.();
    timer.current = setTimeout(() => setSpinning(false), spinDuration);
  }, [thinking, spinning, spinDuration, onSpin]);

  const handleKey = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      spin();
    }
  };

  const animation = thinking
    ? 'gyeno-spin 1.1s linear infinite'
    : spinning
      ? `gyeno-spin ${spinDuration}ms cubic-bezier(.65,0,.35,1)`
      : 'none';

  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      role={interactive ? 'button' : 'img'}
      tabIndex={interactive ? 0 : undefined}
      aria-label={thinking ? 'Gyeno is thinking' : 'Gyeno'}
      onClick={interactive ? spin : undefined}
      onKeyDown={interactive ? handleKey : undefined}
      style={{
        cursor: interactive ? 'pointer' : 'default',
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
      }}
      {...rest}
    >
      <g fill="none" strokeLinecap="round">
        <path d={ARC_A} stroke={teal} strokeWidth="8" />
        <path d={ARC_B} stroke={teal} strokeWidth="8" />
      </g>
      <circle cx="50" cy="50" r="7.5" fill={teal} />
      <path
        className="gyeno-arc"
        d={ARC_C}
        fill="none"
        stroke={CORAL}
        strokeWidth="11"
        strokeLinecap="round"
        style={{ transformOrigin: '50px 50px', animation }}
      />
    </svg>
  );
}
